Object.defineProperty(exports,"__esModule",{value:true});exports.getEventId=void 0;var getEventId=function getEventId(domain,event){return domain?domain+":"+event:event;};exports.getEventId=getEventId;
//# sourceMappingURL=getEventId.js.map